module.exports = __webpack_public_path__ + "img/mbg.6ef27b34.svg";